import React, { useState, KeyboardEvent, MouseEvent } from 'react';
import { Box, Drawer, List, Divider, ListItem, ListItemButton, ListItemIcon } from '@mui/material';
import { List as ListPhosphor, Files } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../providers/theme';
import { TextComponent } from '../TextComponent';
import { useTranslation } from 'react-i18next';

type Anchor = 'top' | 'left' | 'bottom' | 'right';

export function TemporaryDrawer() {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const {t} = useTranslation();

  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
      (event: KeyboardEvent | MouseEvent) => {
        if (
          event.type === 'keydown' &&
          ((event as KeyboardEvent).key === 'Tab' ||
            (event as KeyboardEvent).key === 'Shift')
        ) {
          return;
        }

        setState({ ...state, [anchor]: open });
      };

  const listItems = [
    { id: '1', name: (t('sidebar-group-button')), icon: <Files size={28} color='#FFF' />, navigateTo: '/contracts' },
  ];

  const list = (anchor: Anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250, height: '100vh', backgroundColor: '#F9F9F9' }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
        {listItems.map((item) => (
          <ListItem key={item.name} disablePadding sx={{ backgroundColor: theme.colors.main, width: '90%', borderRadius: '6px' }}>
            <ListItemButton onClick={() => navigate(item.navigateTo)}>
              <ListItemIcon>
                {item.icon}
              </ListItemIcon>
              <TextComponent
                children={item.name}
                fontWeight='bold'
                fontSize='18px'
                color='#FFF'
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
    </Box>
  );

  return (
    <div>
      {(['left'] as const).map((anchor) => (
        <React.Fragment key={anchor}>
          <ListPhosphor onClick={toggleDrawer(anchor, true)} size={32} color={theme.colors.main} cursor='pointer' />
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
